import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import {environment} from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../../../../../src/assets/i18n/configuration/configuration.json';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-ctl-prj-setup-review',
  templateUrl: './setupreview.component.html',
  styleUrls: ['./setupreview.component.css']
})
export class SetupreviewComponent implements OnInit {
  @Input() currentstep;
  @Input() gradeData: any[];
  @Input() subjectData: any[];
  @Input() projectData: any;
  @Output() evEdit: EventEmitter<number> = new EventEmitter();

  environment: any;
  loaded:boolean = false;
  languageConfiguration: any;
  textDir:any;
  constructor(public translate: TranslateService) { 
    this.languageConfiguration = (languageConfig as any).default;
    translate.addLangs([this.languageConfiguration.languages]);
    translate.setDefaultLang(this.languageConfiguration.defaultLang);
    let selectedLang = sessionStorage.getItem('selectedLang');
    this.textDir =  sessionStorage.getItem('textDir');
    let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
    if(selectedLang){
      translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
    } else {
      const browserLang = translate.getBrowserLang();                  
      translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
    }  
  }

  ngOnInit() {
    this.currentstep = 2;
    this.environment = environment;
    this.loaded = true;
  }

  ngOnDestroy(){

  }

  goBack(step) {
    this.evEdit.emit(step);
  }
}
